module.exports = __webpack_public_path__ + "img/r-215.330d96ee.jpg";